<template>
  <div>
    <el-form class="form" :model="query" label-width="80px" ref="queryFrom" :rules="rules">
      <el-row :gutter="20">
        <el-col :span="5">
          <el-form-item label="公司" prop="companyCode">
            <el-select v-model="companyCode" style="width: 100%" @change="getDepartment">
              <el-option
                v-for="(item, index) in companyList"
                :label="item.label"
                :value="item.value"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="部门" prop="contractBusinessDepartment">
            <el-select
              v-model="query.contractBusinessDepartment"
              style="width: 100%"
              placeholder="请选择部门"
              @change="resetProject"
            >
              <el-option
                v-for="(item, index) in departmentList"
                :label="item.label"
                :value="item.value"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="项目" prop="projectNo">
            <SearchTable
              ref="searchTable"
              v-model="query.projectNo"
              searchType="projectListWumaoByPage"
              :isMultiple="true"
              :currentValue="query.projectName ? query.projectName : ''"
              :checkRowKeys="query.projectNo ? [query.projectNo] : []"
              :extraData="{
                projectInitiationStatusList: ['PIS04', 'PIS05', 'PIS07', 'PIS08'],
                applyDepartmentNoList: query.contractBusinessDepartment
                  ? [query.contractBusinessDepartment]
                  : (userInfo.allDepartmentList || []).map((v) => v.personDepartmentCode),
                // businessGroup: userInfo.businessGroup,
                // platformtCompanyList: [userInfo.companyCode],
              }"
              @input="(val) => chooseForm(val, 'projectNo')"
            ></SearchTable>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="采购合同" prop="purchaseContractNoLike">
            <SearchTable
              ref="purchaseSearchTable"
              v-model="query.purchaseContractNoList"
              searchType="saleContract"
              :isMultiple="false"
              :currentValue="purchaseContractNoLike ? purchaseContractNoLike : ''"
              :checkRowKeys="
                query.purchaseContractNoList.length ? query.purchaseContractNoList : []
              "
              :extraData="{
                contractCategory: 'purchase',
                projectInitiationNo: query.projectNo ? query.projectNo : '',
                applyDepartmentNo: userInfo.departmentCode,
                applyDepartmentName: userInfo.departmentName,
              }"
              @input="(val) => chooseForm(val, 'purchaseContractNoLike')"
            ></SearchTable>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="销售合同" prop="salesContractNoLike">
            <SearchTable
              ref="salesSearchTable"
              v-model="query.saleContractNoList"
              searchType="saleContract"
              :isMultiple="false"
              :currentValue="salesContractNoLike ? salesContractNoLike : ''"
              :checkRowKeys="query.saleContractNoList.length ? query.saleContractNoList : []"
              :extraData="{
                contractCategory: 'sales',
                projectInitiationNo: query.projectNo ? query.projectNo : '',
                applyDepartmentNo: userInfo.departmentCode,
                applyDepartmentName: userInfo.departmentName,
              }"
              @input="(val) => chooseForm(val, 'salesContractNoLike')"
            ></SearchTable>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6" :offset="18" class="text-right">
          <el-button type="primary" @click="searchTrigger">搜索</el-button>
          <el-button type="primary" @click="exportExcel">导出EXCEL</el-button>
          <el-button type="primary" @click="resetClick">重置</el-button>
        </el-col>
      </el-row>
    </el-form>
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :data="tableData"
        :paging="true"
        :setting="false"
        :customVisible="false"
        :columns="tableColumn"
        :showToolbar="true"
        show-footer
        :footer-method="footerMethod"
        :valid-config="{ autoPos: true, message: 'inline' }"
        :loading="load"
        @dblclickEvent="dblclickEvent"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      >
        <template>
          <vxe-table-column
            :key="index"
            v-for="(i, index) in tableColumn"
            :title="i.title"
            :field="i?.field"
            :formatter="i?.formatter"
            align="center"
          >
            <template v-if="i.children">
              <vxe-table-column
                :key="index"
                v-for="(item, index) in i.children"
                :title="item.title"
                :field="item.field"
                :formatter="i?.formatter"
                align="center"
              >
              </vxe-table-column>
            </template>
          </vxe-table-column>
        </template>
      </sirui-table>
    </div>
  </div>
</template>

<script>
  import DataBaseAPI from '@/api/dataBase';
  import { getUserCompanyList } from '@/common/js/util';
  export default {
    name: 'verificationIncome',
    props: [],
    data() {
      return {
        tableData: [],
        load: false,
        query: {
          contractBusinessDepartment: '',
          projectNo: null,
          projectName: null,
          purchaseContractNoList: [],
          saleContractNoList: [],
          saleExtendContractNoList: [],
          purchaseExtendContractNoList: [],
        },
        companyCode: null,
        companyList: getUserCompanyList(),
        departmentList: [],
        menuButtonList: [],
        footerTotalCols: {
          amount: [
            'paymentAmount',
            'collectionAmount',
            'accumulateChargeAmount',
            'revenueAmount',
            'punctualRevenueAmount',
            'upstreamDiscountInterest',
            'ourDiscountInterest',
            'incomeAmount',
          ],
          quantity: [],
        },
      };
    },
    computed: {
      tableColumn() {
        return [
          {
            field: 'expenseDate',
            title: '收、付款日期',
            visible: true,
          },
          {
            field: 'paymentAmount',
            title: '付款',
            visible: true,
            formatter: this.formatterNum,
          },
          {
            field: 'collectionAmount',
            title: '收款',
            visible: true,
            formatter: this.formatterNum,
          },
          {
            field: 'accumulateChargeAmount',
            title: '累计计费金额',
            visible: true,
            formatter: this.formatterNum,
          },
          {
            title: '计息起止时间',
            field: '',
            children: [
              {
                field: 'interestStartDate',
                title: '起始时间',
                visible: true,
              },
              {
                field: 'interestEndDate',
                title: '截止时间',
                visible: true,
              },
            ],
          },
          {
            title: '计算方式',
            field: '',
            children: [
              {
                field: 'days',
                title: '天数',
                visible: true,
              },
              {
                field: 'dailyRate',
                title: '日费率',
                visible: true,
              },
            ],
          },
          {
            title: '收益金',
            field: 'revenueAmount',
            visible: true,
            formatter: this.formatterNum,
          },
          {
            title: '实时收益金',
            field: 'punctualRevenueAmount',
            visible: true,
            formatter: this.formatterNum,
          },
          {
            title: '上游承担贴息费用',
            field: 'upstreamDiscountInterest',
            visible: true,
            formatter: this.formatterNum,
          },
          {
            title: '我司承担贴息费用',
            field: 'ourDiscountInterest',
            visible: true,
            formatter: this.formatterNum,
          },
          {
            title: '应收收益',
            field: 'incomeAmount',
            visible: true,
            formatter: this.formatterNum,
          },
          // {
          //   title: '已开票体现收益',
          //   field: 'invoicedRevenue',
          //   visible: true,
          // },
          // {
          //   title: '未开票体现收益',
          //   field: 'noInvoicedRevenue',
          //   visible: true,
          // },
        ];
      },
      purchaseContractNoLike() {
        if (this.query.purchaseContractNoList && this.query.purchaseContractNoList.length != 0) {
          return this.query.purchaseContractNoList.join(',');
        }
        return '';
      },
      salesContractNoLike() {
        if (this.query.saleContractNoList && this.query.saleContractNoList.length != 0) {
          return this.query.saleContractNoList.join(',');
        }
        return '';
      },
      rules() {
        return {
          projectNo: [
            {
              required: true,
              message: '项目必填',
            },
          ],
        };
      },
    },
    // activated() {
    //   if (!this.query.projectNo) {
    //     this.$message.warning('请选择项目');
    //   }
    // },
    mounted() {
      this.getTableData();
      this.getDepartment(this.userInfo.companyCode);
      this.$refs.siruiTable.setPageNum(1);
      this.$refs.siruiTable.setPageSize(10);
      this.query.contractBusinessDepartment = this.userInfo.departmentCode;
      this.companyCode = this.userInfo.companyCode;
    },
    methods: {
      formatterNum({ cellValue }) {
        if (!cellValue && isNaN(cellValue)) return null;
        return this.$utils.commafy(this.$utils.toNumber(cellValue), { digits: 2 });
      },
      // 搜索按钮
      searchTrigger() {
        this.$refs.siruiTable.clearCheckboxReserve();
        // if(this.query.projectNo==''||this.query.projectNo==null){
        //   return this.$message.warning('请选择项目！')
        // }
        this.getTableData();
      },
      // 重置按钮
      resetClick() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.$refs.siruiTable.clearCheckboxReserve();
        if (this.$refs.searchTable) {
          this.$refs.searchTable.resetClick();
        }
        if (this.$refs.salesSearchTable) {
          this.$refs.salesSearchTable.resetClick();
        }
        if (this.$refs.purchaseSearchTable) {
          this.$refs.purchaseSearchTable.resetClick();
        }
        this.$refs.queryFrom.resetFields();
        (this.query = {
          contractBusinessDepartment: '',
          projectNo: null,
          projectName: null,
          purchaseContractNoList: [],
          saleContractNoList: [],
          saleExtendContractNoList: [],
          purchaseExtendContractNoList: [],
        }),
          (this.query.contractBusinessDepartment = this.userInfo.departmentCode);
        if (!this.query.projectNo) {
          this.$message.warning('请选择项目');
        }
        this.$nextTick(() => {
          this.$forceUpdate();
          this.getTableData();
        });
      },
      chooseForm(val, type) {
        console.log(val, '---');

        if (type == 'projectNo') {
          const rowData = val && Array.isArray(val) && val.length ? val[0] : {};
          this.query.projectNo = rowData.projectInitiationNo;
          this.query.projectName = rowData.projectName;
          this.query.purchaseContractNoList = [];
          this.query.saleContractNoList = [];
        } else if (type == 'purchaseContractNoLike') {
          if (val && Array.isArray(val) && val.length) {
            this.query.purchaseContractNoList = val
              .filter((item) => item.contractNo)
              .map((item) => item.contractNo);
            this.query.purchaseExtendContractNoList = val
              .filter((item) => item.contractNo)
              .map((item) => item.externalContractNo);
          } else {
            this.query.purchaseContractNoList = [];
            this.query.purchaseExtendContractNoList = [];
          }
        } else if (type == 'salesContractNoLike') {
          if (val && Array.isArray(val) && val.length) {
            this.query.saleContractNoList = val
              .filter((item) => item.contractNo)
              .map((item) => item.contractNo);
            this.query.saleExtendContractNoList = val
              .filter((item) => item.contractNo)
              .map((item) => item.externalContractNo);
          } else {
            this.query.saleContractNoList = [];
            this.query.saleExtendContractNoList = [];
          }
        }
      },
      async exportExcel() {
        // this.query.contractBusinessDepartment = '';
        let params = { ...this.query };
        if (this.companyCode) {
          params.companyName = this.companyList?.find(
            (item) => item.value == this.companyCode
          )?.label;
        }
        if (params.contractBusinessDepartment) {
          params.departmentName = this.departmentList?.find(
            (item) => item.value == params.contractBusinessDepartment
          )?.label;
        }
        if (params.saleContractNoList && !params.saleContractNoList.length) {
          delete params.saleContractNoList;
        }
        if (params.purchaseContractNoList && !params.purchaseContractNoList.length) {
          delete params.purchaseContractNoList;
        }
        if (params.purchaseExtendContractNoList && !params.purchaseExtendContractNoList.length) {
          delete params.purchaseExtendContractNoList;
        }
        if (params.saleExtendContractNoList && !params.saleExtendContractNoList.length) {
          delete params.saleExtendContractNoList;
        }
        const { data } = await this.$axios.post(
          '/financial/statistic/revenueDetail/export',
          params
        );
        if (data.code === 0) {
          this.$message({
            showClose: true,
            message: data.msg,
            type: 'success',
          });
          // console.log(data.data);
          window.location.href = data.data.word;
        } else {
          this.$alert(data.msg);
        }
        console.log('导出');
      },
      handleSizeChange() {
        this.getTableData();
      },
      handleCurrentChange() {
        this.getTableData();
      },

      //双击事件
      dblclickEvent({ row }) {
        console.log(row);
      },
      // 选中触发事件
      // handleSelectionChange(row) {
      //   this.multipleSelection = row;
      //   console.log(row);
      // },
      footerMethod({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return '合计';
            }
            for (let key in this.footerTotalCols) {
              if (this.footerTotalCols[key].includes(column.property)) {
                let total = this.$utils.calSum(data, column.property);
                let point = this.$globalVar.aPoint;
                if (key == 'quantity') {
                  point = this.$globalVar.qPoint;
                }
                total = this.$utils.commafy(this.$utils.toNumber(total), { digits: point });
                return total;
              }
            }
            return null;
          }),
        ];
      },
      resetProject() {
        if (!this.companyCode) {
          this.query.contractBusinessDepartment = null;
        }
        this.query.projectNo = null;
        this.query.projectName = null;
      },
      async getDepartment(companyCode) {
        this.query.contractBusinessDepartment = null;
        this.resetProject();
        if (companyCode) {
          let params = {
            id: this.userInfo.userCode,
            userCode: this.userInfo.userCode,
            personName: this.userInfo.userName,
            personCompanyCode: companyCode,
          };
          const { data } = await this.$axios.post(DataBaseAPI.GET_PERSON_API, params);
          if (data.code == 0) {
            this.departmentList = data.data.personDepartmentInfo.map((item) => {
              return {
                value: item.personDepartmentCode,
                label: item.personDepartmentName,
              };
            });
          }
        } else {
          this.departmentList = [];
        }
      },
      async getTableData() {
        this.load = true;
        let params = {
          ...this.query,
          pageNum: this.$refs.siruiTable.page.pageNum,
          pageSize: this.$refs.siruiTable.page.pageSize,
        };
        if (params.saleContractNoList && !params.saleContractNoList.length) {
          delete params.saleContractNoList;
        }
        if (params.purchaseContractNoList && !params.purchaseContractNoList.length) {
          delete params.purchaseContractNoList;
        }
        if (params.purchaseExtendContractNoList) {
          delete params.purchaseExtendContractNoList;
        }
        if (params.saleExtendContractNoList) {
          delete params.saleExtendContractNoList;
        }
        const { data } = await this.$axios.post('/financial/statistic/revenueDetail/page', params);
        this.load = false;
        if (data.code == 0) {
          this.tableData = data.data.list;
          this.$refs.siruiTable.setPageTotal(data.data.total);
        } else {
          this.tableData = [];
        }
      },
    },
    components: {},
    watch: {},
  };
</script>

<style lang="scss" scoped></style>
